"use client";

import { cn } from "@repo/shared/utils";
import { AlertCircleIcon } from "lucide-react";

export type InputInfoType = "error" | "warning" | "information" | "success";

interface InputInfoProps {
  info: string | { message: string; type: InputInfoType };
  className?: string;
}

const classesByType: Map<InputInfoType, string> = new Map([
  ["error", "text-destructive"],
  ["warning", "text-yellow-600"],
  ["information", "text-blue-600"],
  ["success", "text-emerald-600"],
]);

export const InputInfo = ({ info, className }: InputInfoProps) => {
  const message = typeof info === "string" ? info : info.message;
  const infoType: InputInfoType =
    typeof info === "string" ? "error" : info.type;
  const infoClass = classesByType.get(infoType);
  return (
    <div
      className={cn("text-base italic  flex flex-row", className, infoClass)}
    >
      <div>
        <AlertCircleIcon className="w-6 h-6" />
      </div>
      <div className="ml-2">{message}</div>
    </div>
  );
};
